
import { BrowserRouter, Routes, Route } from 'react-router-dom'

import Dashboard from './pages/Dashboard'
import { useContext } from 'react'
import { ThemeContext } from './components/ThemeContext'
import Login from './pages/Login'
import Unsubscription from './pages/Unsubscription'
import PaidSubscription from './pages/PaidSubscription'
import GameDetails from './pages/GameDetails'
import AirtimeWinners from './pages/AirtimeWinners'
import BilledFailed from './pages/BilledFailed'
import SubBilling from './pages/SubBilling'
import AcquiredPaidSubscribedd from './pages/AcquiredPaidSubscribedd'
import AcquiredSubscribed from './pages/AcquiredSubscribed'
import GameById from './pages/GameById'
import WinnersByCurrency from './pages/WinnersByCurrency'
import Renewals from './pages/Renewals'
import MisReport from './pages/MisReport'

function App() {
    const { theme } = useContext(ThemeContext);
    
    return (
        <div className={`${theme === 'dark' ? 'bg-black shadow-black text-white' : 'bg-white'}`}>
            <BrowserRouter>
        
                  
        <Routes>
            
            <Route path='/' element={<Dashboard />} />
            <Route path='/login' element={<Login/>}/>
            <Route path='/unsub' element={<Unsubscription/>}/>
            <Route path='/paid/subscription' element={<PaidSubscription/>}/>
            <Route path='/gamedetails' element={<GameDetails/>}/>
            <Route path='/winners' element={<AirtimeWinners/>}/>
            <Route path='/billedfailed' element={<BilledFailed/>}/>
            <Route path='/subbilled' element={<SubBilling/>}/>
            <Route path='/paid-subscribe' element={<AcquiredPaidSubscribedd/>}/>
            <Route path='/subscribed' element={<AcquiredSubscribed/>}/>
            <Route path ='/game' element={<GameById/>}/>
            <Route path='/winners-currency' element={<WinnersByCurrency/>}/>
            <Route path='/renewals' element={<Renewals/>}/>

            <Route path='/misreport' element={<MisReport/>}/>





           

          
        </Routes>

</BrowserRouter>
        </div>
        

        
        
    )
}

export default App
